/* eslint-disable react/jsx-props-no-spreading */
import { Col, Row, Form, Input, InputNumber } from 'antd';
import { ReactComponent as IconReloj } from 'assets/images/monitoreos/SIMAC_Icono_reloj.svg';
import PropTypes from 'prop-types';

const ComplementoVisita = ({ form }) => {
  const { TextArea } = Input;
  const idEvento = form.getFieldValue(['identificadorEvento']);

  return (
    <div>
      <Form form={form} layout="vertical">
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={9} className="col-reloj-completo">
            {idEvento && (
              <Form.Item label="Duración del evento:">
                <div className="div-reloj-campo-completo">
                  <div>
                    <IconReloj className="reloj-icon-completo" />
                  </div>
                  <Form.Item name="duracionHr" className="item-duracion-evento">
                    <InputNumber
                      className="reloj-input-completo"
                      placeholder="00"
                      min={0}
                      max={24}
                      keyboard
                    />
                  </Form.Item>
                  <div className="div-p-time">
                    <p>hrs.</p>
                  </div>
                  <Form.Item name="duracionMin" className="item-duracion-evento">
                    <InputNumber
                      className="reloj-input-completo"
                      placeholder="00"
                      min={0}
                      max={60}
                      keyboard
                    />
                  </Form.Item>
                  <div className="div-p-time">
                    <p>min.</p>
                  </div>
                  <Form.Item name="duracionSeg" className="item-duracion-evento">
                    <InputNumber
                      className="reloj-input-completo"
                      placeholder="00"
                      min={0}
                      max={60}
                      keyboard
                    />
                  </Form.Item>
                  <div className="div-p-time">
                    <p>seg.</p>
                  </div>
                </div>
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>
            <Form.Item
              className="input-textarea"
              name="manifestacion"
              label="Manifestación del compareciente:">
              <TextArea
                showCount
                maxLength={3800}
                allowClear
                placeholder="Escribe..."
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>
            <Form.Item className="input-textarea" name="otrosHechos" label="Otros hechos:">
              <TextArea
                showCount
                maxLength={1200}
                allowClear
                placeholder="Escribe..."
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>
            <Form.Item
              className="input-textarea"
              name="infAdicional"
              label="Información adicional:">
              <TextArea
                showCount
                maxLength={5000}
                allowClear
                placeholder="Escribe..."
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

ComplementoVisita.propTypes = {
  form: PropTypes.shape({
    getFieldValue: PropTypes.func
  }).isRequired
};

export default ComplementoVisita;
